import React from 'react'
import { BrowserRouter, Route, Switch } from "react-router-dom";
import PDF from "./pages/PDF";
import Home from "./pages/Home";

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path={'/'} component={Home} exact />
        <Route path={'/:name'} component={PDF} exact />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
